import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from "react-router-dom";
const CardContacto =
  ({
    contact,
    setSelectContact,
    user,
    handlerOpenModalObservaciones,
    handlerOpenModal,
    formData,
    setFormData,
    selectedContact,
    setIdContact
  }) => {
    const navigate = useNavigate();
    const [editorContacto, setContacto] = useState(false);
    function convertirFecha(fechaString) {
      const fecha = new Date(fechaString);
      const dia = fecha.getDate();
      const mes = fecha.getMonth() + 1; // Los meses comienzan desde 0, por lo que se suma 1
      const año = fecha.getFullYear();
      const hora = fecha.getHours();
      const minutos = fecha.getMinutes();

      // Formatear los componentes de la fecha/hora para que tengan dos dígitos
      const diaFormateado = dia < 10 ? '0' + dia : dia;
      const mesFormateado = mes < 10 ? '0' + mes : mes;
      const horaFormateada = hora < 10 ? '0' + hora : hora;
      const minutosFormateados = minutos < 10 ? '0' + minutos : minutos;

      // Construir la cadena de fecha en el formato deseado
      const fechaFormateada =
        `${horaFormateada}:${minutosFormateados}hs - ${diaFormateado}/${mesFormateado}/${año}`;

      return fechaFormateada;
    }
    const sendDetallePath = (contact) => {
      setIdContact(contact.id)
      // navigate('/seguimientos/' + `${contact.id}`)
    }
    return (

      <DivRow style={{
        backgroundColor: selectedContact?.id === contact.id ? '#dddddd' : '#FFFFFF'
      }}

        onClick={() => sendDetallePath(contact)}
        key={contact.id}>
        {/* <img 
        src={contact?.imageProfile || example}
        style={{
          width: '28px',
          height: '28px',
          borderRadius: '100%',
        }}
        /> */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',

          }} >
            <Text
              selectedContact={selectedContact}
              contact={contact}>

              {contact.name} {contact.lastname}

            </Text>
            <Text
              style={{
                fontSize: '10px',
              }}
              selectedContact={selectedContact}
              contact={contact}>
              {
                contact.Observaciones && contact.Observaciones?.length > 0 ?
                  <>
                    {'Último contacto ' + convertirFecha(contact.Observaciones[contact.Observaciones.length - 1].updatedAt)} </> : 'Sin contactar'
              }


            </Text>
          </div>
          {/* <Text>{contact.dni}</Text> */}



          {/* <Text>{contact.phone}</Text>
                <Text>{contact.email}</Text> */}
          {/*  <BotonCalendar
                    onClick={() => handlerOpenModalObservaciones()}
                >
           
                    <CalendarIconImg src={observacionesIcon} />
                </BotonCalendar> */}
          {/* {
                    user === 'Admin' ?
                        <Text>{contact.asesorAsignado}</Text>
                        : null
                } */}

          {/* <BotonCalendar
                    onClick={() => handlerOpenModal()}
                >
                  
                    <CalendarIconImg src={calendarIcon} />
                </BotonCalendar> */}
          {/* {
                    user === 'Admin' ?
                        <Text>{contact.origen}</Text>
                        : null
                } */}

          {/* <Text>{contact.viaDeContacto}</Text> */}

          {/* {
                    editorContacto && user === 'admin' ?
                        <Dropdown
                            options={['contactado', 'no contactado']}
                            selectedOption={contact.status}
                            setSelectedOption={(option) => setFormData({ ...formData, ramo: option })}
                        /> :
                        <Text style={{
                            fontSize: '11px'
                        }}>{contact.status}</Text>
                } */}

          {/* <input type='checkbox' /> */}

          {/* <IconItem src={iconEditar} /> */}
      </DivRow>
    );
  };

export default CardContacto;

const TextSpan = styled.span`
width: -webkit-fill-available;
font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #07082c;
max-width:100px;
overflow-x: scroll;
&::-webkit-scrollbar {
  height: 4px;
  width: 3px;
  background-color: transparent !important;
}

&::-webkit-scrollbar-track {
  background: transparent;
}

&::-webkit-scrollbar-thumb {
  background-color: #003049 !important;
  border-radius: 8px;
}
`;
const CalendarIconImg = styled.img`
  max-width:24px;
  max-height:28px;
  width:24px;
  height:28px;
  
`;

const BotonCalendar = styled.div`
// background-color: #f8f9fa;

border-radius: 100%;
border-color: #dadce0;
box-shadow: rgba(0, 0, 0, .1) 0 1px 1px;
cursor: pointer;
height: 30px;
margin: 0px 16px 0px 16px;
width: -webkit-fill-available;
align-self: center;
align-content: center;
width: 25px;
gap:8px;
font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #07082c;
  padding:4px 8px;
  display:flex;
  flex-direction:row;
  align-items:center;
  justify-content: center;
  
  &:focus {
    // border-color: #380418;
    outline: none;
  }
  &:hover {
    transition: all 0.1s linear;
    filter: opacity(0.9);
    transform:scale(0.90)
  }
`;

const Text = styled.span`
width: -webkit-fill-available;
font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: ${(prop) => prop.selectedContact?.id === prop.contact.id ? '#07082c' : '#07082c'}  ;
`;
const DivRow = styled.div`
width: -webkit-fill-available;
padding: 8px;

display: flex;
flex-direction: row;
gap: 5px;
height: auto;
align-content: flex-start;
justify-content: start;
align-items: center;
border-top: 1.5px solid #e1e3ea;
box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
cursor: pointer;
background-color: 'transparent' ;
transition: all 0.3s ease-in-out;
&:hover{
    box-shadow: rgba(60, 64, 67, 0.9) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
    // height:8vh;
    opacity: 0.5;
    will-change: transform;
}
&:active{

  

    will-change: transform;
    
}
`;


const IconItem = styled.img`
width:24px;
height:24px;
min-height:24px;
min-width:24px;
padding:5px;
border-radius:50%;
border-color: #dadce0;
box-shadow: rgba(0, 0, 0, .2) 0 1px 1px;
cursor:pointer;
&:hover{
    border-color: #dadce0;
    box-shadow: rgba(0, 0, 0, .2) 0 1px 1px;
    background-color: #00304954;
    border-radius:50%;
    padding:5px;
}
&:active{
    border-color: #dadce0;
    box-shadow: rgba(0, 0, 0, .2) 0 1px 1px;
    background-color: #00304954;
    border-radius:50%;
    padding:5px;
}
`;
